import { module } from 'modujs'

export default class Filters extends module {

    static get settings() {
        return {
            CLASS_ACTIVE: 'is-active',
        }
    }

    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
        const links = this.$('link')
        this.$elements = links.length > 0 ? Array.from(links) : Array.from(this.$('button'))

        // Vars
        this.transition = this.getData('transition') || null
        this.$activeFilter = this.$elements.find($el => $el.classList.contains('is-active'))

        // Events
        this.events = {
            click: {
                link: 'handleLink',
                button: 'handleButton',
            }
        }
    }

    init() {
    }

    handleLink(e) {
        e.stopPropagation()
        e.preventDefault()
        const $target = e.curTarget

        if ($target === this.$activeFilter) {
            return
        }

        const url = $target.href
        const transition = this.transition

        this.setActive($target)
        this.call('goTo', { url, transition }, 'Load')
    }

    handleButton(e) {
        const $target = e.curTarget

        if ($target === this.$activeFilter) {
            return
        }

        this.setActive($target)
        this.call('update', $target.dataset.id, 'TeamList')
    }

    setActive($target) {

        if (this.$activeFilter !== null) {
            this.$activeFilter.classList.remove(Filters.settings.CLASS_ACTIVE)
        }

        $target.classList.add(Filters.settings.CLASS_ACTIVE)

        this.$activeFilter = $target
    }
}
